// src/api/axiosClient.js
import axios from 'axios';

// Create base axios instance
const axiosClient = axios.create({
	baseURL: import.meta.env.VITE_JSON_API_BASE_URL || 'localhost:4000',
	headers: {
		'Content-Type': 'application/vnd.api+json'
	},
	timeout: 10000 // 10 seconds
});

// Request interceptor
axiosClient.interceptors.request.use(
	(config) => {
		// Get token from localStorage
		const tokenString = sessionStorage.getItem('token');
		const token = tokenString ? JSON.parse(tokenString) : null;
		if (token) {
			config.headers.Authorization = token ? `Bearer ${token.state.token}` : '';
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Response interceptor
axiosClient.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response) {
			// Handle different error status codes
			switch (error.response.status) {
				case 401:
					// Handle unauthorized
					sessionStorage.removeItem('token');
					// Redirect to login or show message
					break;
				case 403:
					// Handle forbidden
					break;
				case 404:
					// Handle not found
					break;
				case 500:
					// Handle server error
					break;
				default:
					// Handle other errors
					break;
			}
		}
		return Promise.reject(error.response.status);
	}
);

// API methods
export const jsonAPI = {
	get: (url: string, config = {}) => axiosClient.get(url, config),
	post: (url: string, data: any, config = {}) => axiosClient.post(url, data, config),
	put: (url: string, data: any, config = {}) => axiosClient.put(url, data, config),
	patch: (url: string, data: any, config = {}) => axiosClient.patch(url, data, config),
	delete: (url: string, config = {}) => axiosClient.delete(url, config)
};

export default jsonAPI;
